<div class="mat-form-field-wrapper w-100">
  <mat-label>{{ fieldObject.fieldName }}</mat-label>
  <button mat-flat-button (click)="fileInput.click()" color="primary">Choose File</button>
  <input #fileInput type="file" [formControl]="formControlRef" class="d-none"/>
  <mat-error *ngIf="fieldErrors[fieldObject.fieldName]">
    {{ fieldErrors[fieldObject.fieldName] }}
  </mat-error>
</div>
